const state = {
	drawerItems: {
		header:{},
		top: {},
		left: {},
		bottom:{},
		right:{}
	},
	 userClosedDrawer: {
    left: false,
    right: false,
    top: false,
    bottom: false
  }
}

const getters = {
	/*drawerIsOpen(state) {
		return Object.keys(state.drawerItems).length > 0;
	}*/
	hasContent(state) {
		return (drawer) => Object.keys(state.drawerItems[drawer]).length > 0;
	}
}

const actions = {
	addToDrawer({commit}, {id, component, drawer, attrs = {}}) {
		commit("ADD_TO_DRAWER", {id, component,drawer, attrs})
	},
	removeFromDrawer({commit}, {id, drawer}) {
		commit("REMOVE_FROM_DRAWER", {id, drawer});
		
	},
	
	openSingleInDrawer({ commit }, { id, component, drawer, attrs = {} }) {
		
		commit('CLEAR_DRAWER', drawer);              //  close whatever was open
		commit('ADD_TO_DRAWER', { id, component, drawer, attrs }); //  open new
}
}

const mutations = {
	ADD_TO_DRAWER(state, {id, component, drawer, attrs}) {
		  console.log('[ADD_TO_DRAWER]', drawer, Object.keys(state.drawerItems[drawer]));

		state.drawerItems[drawer] = Object.assign({}, state.drawerItems[drawer],  {[id]: {component, attrs}});
	},
	REMOVE_FROM_DRAWER(state, {id, drawer}) { //Remove one specific component from a drawer
		const items = state.drawerItems[drawer];
		delete items[id];
		state.drawerItems[drawer] = Object.assign({}, items);
	},
	CLEAR_DRAWER(state, drawer) {//Remove everything from a drawer, Drawer becomes empty
  		state.drawerItems[drawer] = {};
		}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
